import React, { useEffect, useState } from "react";
import { TabOne } from "./Tab1Components/TabOne";
import { TabTwo } from "./Tab1Components/TabTwo";
import { TabThree } from "./Tab1Components/TabThree";
import { TabFour } from "./Tab1Components/TabFour";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Alert } from "react-bootstrap";
import CustomLoader from "../../CustomLoader";
import api from "../../../utils/api";

export const Tab1 = ({
  rowActions, setRowActions,
  setSelectedCards,
  selectedCards,
  setSelectedTab,
  setHistoryActiveTab,
  selectedTab,
  setPrsuggections,
  isPrsuggections,
  selectedMember,
  setSelectedMember,
  isChecked,
  setIsChecked,
  schemeCode, setSchemeCode,
  setActiveTab,
  searchParamsPRFail
}) => {
  const navigate = useNavigate();
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const dispatch = useDispatch();

  const [isPortfolioData, setIsPortfolioData] = useState({});
  const [loading, setLoading] = useState(false)
  const [hasHouseHold, setHasHouseHold] = useState(false);
  const [hsData, setHsData] = useState({});
  const { clientData } = useSelector((state) => state.client);

  // Fetch client info on mount
  useEffect(() => {
    dispatch(fetchClientData(roomId));
  }, []);

  // Step 1: Get household members
  useEffect(() => {

    if (
      selectedMember &&
      typeof selectedMember.pan === "string" &&
      typeof selectedMember.client_name === "string"
    ) {
      // console.log("Skipping getInvestor – member already selected", selectedMember);
      setHasHouseHold(true);

      return; // ✅ Do not call getInvestor
    }

    const getInvestor = async () => {
      try {
        const response = await api.get(
          `advisor/gethouseHoldPanInfo/${roomId}`
        );
        const bankDetails = response.data;
        console.log("selectedMember", selectedMember, bankDetails);

        console.log('bankDetails', bankDetails)
        if (bankDetails.length > 0) {

          setHsData(bankDetails[0])
          setHasHouseHold(true);
          if (bankDetails.length === 1) {
            setSelectedMember(bankDetails[0]);
          } else {
            setSelectedMember({ pan: "all", client_name: "Household", groupId: bankDetails[0]?.groupId || null });
          }
        } else {
          setHasHouseHold(false);
        }
      } catch (error) {
        console.error("Error fetching household PAN info:", error);
        setSelectedMember({ pan: "all", client_name: "Household" });
      }
    };

    getInvestor();
  }, []);
  // console.log("hasHouseHold", hasHouseHold);


  // Step 2: Fetch portfolio data after member is selected
  useEffect(() => {


    if (
      selectedMember &&
      typeof selectedMember.pan === "string" &&
      typeof selectedMember.client_name === "string"
    ) {
      fetchPortfolioData();
    }

  }, [selectedMember, hasHouseHold]);

  const fetchPortfolioData = async () => {

    setLoading(true)
    // Swal.fire({
    //   text: "Please wait...",
    //   imageUrl: "https://www.finedge.in/assets/images/download.gif",
    //   showConfirmButton: false,
    //   allowOutsideClick: false,
    // });
    try {
      const isHousehold = selectedMember?.pan === "all";

      // const allData = isHousehold
      //   ? { panval: "all_Household", clientid: roomId }
      //   : {
      //     panval: `${selectedMember.pan}_${selectedMember.client_name}`,
      //     clientid: roomId,
      //   };
      console.log('hsData', hsData, selectedMember, searchParamsPRFail)
      const allData = isHousehold
        ? { groupId: selectedMember.groupId, memberId: "", clientid: roomId }
        : { groupId: selectedMember.groupId, memberId: selectedMember.wo_id, clientid: roomId }

      const payloadData = {
        ...allData,
        ...(searchParamsPRFail != null && { prf: searchParamsPRFail }),
      };

      const response = await api.post(
        "advisor/get_live_portfolioWM",
        payloadData
      );


      // if (response.data?.prinfo === null) {
      //   setSelectedTab(0); // No open review
      // }
      if (response.data) {
        console.log("Portfolio data fetched successfully:", response.data);
        setIsPortfolioData(response.data);
        Swal.close();
      }

    } catch (error) {
      // navigate(`/?clientId=${roomId}`);
      console.error("Error fetching portfolio data:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to load portfolio data. Please try again later.",
      });
      Swal.close();

    } finally {
      setTimeout(() => {

        setLoading(false)
      }, 500);
    }
  };
  // console.log('selectedCards', selectedMember, hasHouseHold);


  if (loading) {
    return (
      <>
        <CustomLoader />
      </>
    )
  }
  if (!hasHouseHold) {
    return (
      <Alert
        variant="success"
        className="fw-bold d-block text-center mt-4"
      >
        Household data not avilable.
      </Alert>
    )
  }

  if (isPortfolioData && !isPortfolioData?.prinfo) {
    return (
      <Alert
        variant="success"
        className="fw-bold d-block text-center mt-4"
      >
        No open portfolio review.
      </Alert>
    )

  }

  return (
    <div className="row">
      <div className="col">
        {/* {isPortfolioData?.prinfo?.portfolio_review_id} */}
        <>




          {selectedTab === 1 && (
            <TabOne
              setSelectedCards={setSelectedCards}
              selectedCards={selectedCards}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              clientData={clientData}
              setPrsuggections={setPrsuggections}
              isPrsuggections={isPrsuggections}
              isPortfolioData={isPortfolioData}
              searchParamsPRFail={searchParamsPRFail}
            />
          )}

          {selectedTab === 2 && (
            <TabTwo
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              isPrsuggections={isPrsuggections}
              isPortfolioData={isPortfolioData}
              fetchPortfolioData={() => { }} // optional
              setPrsuggections={setPrsuggections}
            />
          )}

          {selectedTab === 3 && (
            <TabThree
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              isPortfolioData={isPortfolioData}
              setIsChecked={setIsChecked}
              isChecked={isChecked}
            />
          )}

          {selectedTab === 4 && (
            <TabFour
              schemeCode={schemeCode} setSchemeCode={setSchemeCode}
              rowActions={rowActions} setRowActions={setRowActions}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              roomId={roomId}
              isPortfolioData={isPortfolioData}
              setSelectedMember={setSelectedMember}
              fetchPortfolioData={fetchPortfolioData}
              selectedMember={selectedMember}
              setHistoryActiveTab={setHistoryActiveTab}
              setActiveTab={setActiveTab}

            />
          )}
        </>

      </div>
    </div>
  );
};
